module.exports = __webpack_public_path__ + "img/beepgo-logo.266add02.png";